<template>

  <div id="navigation" :class="{hidden: !$store.getters.isMenuVisible(this.$route)}">

    <div class="main-navigation">

      <!-- Super admin navigation -->
      <template v-if="!$route.query.branch && !$route.query.company && atLeastDistributor">
        <template v-if="exactlySuperAdmin">
          <NavigationLink @click="$emit('close-menu')" icon="/icon/nav/revenue-center.svg" url="/branches" >{{ $t('branches.title') }}</NavigationLink>
        </template>
        <template v-if="exactlyDistributor">
          <NavigationLink @click="$emit('close-menu')" icon="/icon/nav/revenue-center.svg" url="/user-branches" >{{ $t('branches.title') }}</NavigationLink>
        </template>
        <template v-if="atLeastDistributor">
          <Collapse closed :text="$t('advanced_navigation.global_reports')" icon="/icon/nav/analytics.svg" url="/global-reports-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/stats-builder">{{ $t('statistics.title') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/report/customer" v-if="atLeastSuperAdmin">{{ $t('advanced_navigation.customer_report') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/stats-payment" v-if="atLeastSuperAdmin">{{ $t('advanced_navigation.stats_payment') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/sms-report" v-if="atLeastSuperAdmin">{{ $t('advanced_navigation.sms_Report') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/anomaly-reports" v-if="atLeastSuperAdmin">{{ $t('advanced_navigation.anomaly_reports') }}</NavigationLink>
          </Collapse>
        </template>
        <template v-if="atLeastDistributor">
          <Collapse closed icon="/icon/nav/bug.svg" :text="$t('advanced_navigation.global_support_debug')" url="/global-support-debug-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/failed-sales" v-if="atLeastSuperAdmin">{{ $t('advanced_navigation.failed_sales') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/company-change-log">{{ $t('advanced_navigation.company_change_log') }}</NavigationLink>
          </Collapse>
        </template>
        <template v-if="atLeastDistributor">
          <Collapse closed :text="$t('advanced_navigation.monitoring_tools')" icon="/icon/nav/monitoring.svg" url="/monitoring-tools-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/heartbeat">{{ $t('advanced_navigation.heartbeat') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/server-status" v-if="atLeastSuperAdmin">{{ $t('advanced_navigation.servers_status') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/tunnel-migration" v-if="atLeastSuperAdmin">{{ $t('advanced_navigation.tunnel_migration') }}</NavigationLink>
          </Collapse>
        </template>
        <template v-if="atLeastSuperAdmin">
          <Collapse closed icon="/icon/nav/taxes.svg" :text="$t('advanced_navigation.taxes')" url="/taxes-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/taxes">{{ $t('taxes.title') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/tax-groups">{{ $t('tax_groups.title') }}</NavigationLink>
          </Collapse>
        </template>
        <template v-if="atLeastSuperAdmin">
          <Collapse closed icon="/icon/nav/tools.svg" :text="$t('advanced_navigation.low_level')" url="/low-level-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/admin-commands">{{ $t('advanced_navigation.command_line_runner') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/move-company">{{ $t('advanced_navigation.move_company') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/app-versions">{{ $t('app_versions.title') }}</NavigationLink>
          </Collapse>
        </template>
        <template v-if="atLeastSuperAdmin">
          <collapse closed :text="$t('users.title')" icon="/icon/nav/users.svg" url="/admin-users-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/users/ROLE_DISTRIBUTOR">{{$t('roles.ROLE_DISTRIBUTOR')}}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/users/ROLE_SUPER_ADMIN">{{$t('roles.ROLE_SUPER_ADMIN')}}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/api-keys">{{$t('apiKeys.title')}}</NavigationLink>
          </collapse>
        </template>
        <template v-if="atLeastSuperAdmin">
          <Collapse closed icon="/icon/nav/recommender.svg" :text="$t('advanced_navigation.recommender')">
            <NavigationLink dot @click="$emit('close-menu')" url="/training-image-classification">{{ $t('classification.training-set') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/recommender-analysis">{{ $t('recommender_analysis.title') }}</NavigationLink>
          </Collapse>
        </template>
      </template>

      <!-- Branch admin navigation -->
      <template v-if="$route.query.branch && !$route.query.company && atLeastBranchAdmin">
        <template v-if="exactlySuperAdmin">
          <NavigationLink :custom-url="{ path: '/branches' }" icon="/icon/back.svg" @click="$emit('close-menu')">
            {{ $t('navigation.back_to_super_admin') }}
          </NavigationLink>
        </template>
        <template v-if="exactlyDistributor">
          <NavigationLink :custom-url="{ path: '/user-branches' }" icon="/icon/back.svg" @click="$emit('close-menu')">
            {{ $t('navigation.back_to_distributor') }}
          </NavigationLink>
        </template>
        <NavigationLink icon="icon/internet.svg" @click="$emit('close-menu')" v-if="moduleActivated.onlineOrdering"
                        :external-url="frontendBranchUrl">{{ $t('open_online_ordering') }}</NavigationLink>
        <template v-if="atLeastSuperAdmin">
          <Collapse closed :text="getContextName" icon="/icon/nav/revenue-center.svg" url="/organization-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/branch/edit">{{ $t('branch.title') }}</NavigationLink>
            <Collapse closed dot :text="$t('advanced_navigation.global_settings')" url="/branch/global-settings-hub">
              <NavigationLink dot @click="$emit('close-menu')" url="/branch/services">{{ $t('services.title') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/branch/inventories">{{ $t('branches.inventories') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/file-import">{{ $t('advanced_navigation.file_import') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/branch-payment">{{ $t('advanced_navigation.branch_payment') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/settings/services/online-ordering">{{ $t('services.online_ordering') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/settings/services/mobile-app" v-if="moduleActivated.mobileApp">{{ $t('settings.mobileapp') }}</NavigationLink>
              <template v-if="!exactlyDistributor">
                <NavigationLink dot @click="$emit('close-menu')" url="/loyalty-config">{{ $t('loyalty.title') }}</NavigationLink>
              </template>
              <NavigationLink dot @click="$emit('close-menu')" url="/clone-inventory">{{ $t('settings_admin.clone_inventory') }}</NavigationLink>
            </Collapse>
            <Collapse closed dot :text="$t('style.title')" url="/visual-config-hub">
              <NavigationLink dot @click="$emit('close-menu')" url="/style/online-ordering">{{ $t('services.online_ordering') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/translations">{{ $t('translations.title') }}</NavigationLink>
            </Collapse>
          </Collapse>
        </template>

        <NavigationLink url="/companies" icon="/icon/nav/dashboard.svg" @click="$emit('close-menu')">{{ $t('companies.title') }}</NavigationLink>
        <Collapse closed :text="$t('inventory.multi_title')" icon="/icon/menu.svg" url="/menu/hub" v-if="multiInventoryActivated">

          <div class="inventory-select-holder">
            <label>{{$t('inventory.current')}}</label>
            <select class="inventory-select" v-model="selectedInventory" :disabled="selectInventoryDisabled">
              <option :value="i" v-for="i of inventories">{{$to(i.name)}}</option>
            </select>
          </div>

          <Collapse closed dot :text="$t('configuration')" url="/menu/configuration-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/inventory" v-if="atLeastSuperAdmin">{{ $t('inventory.current_menu_settings') }}</NavigationLink>
            <!-- <NavigationLink dot @click="$emit('close-menu')" url="/branch/inventories">{{ $t('branches.inventories') }}</NavigationLink>-->
            <NavigationLink dot @click="$emit('close-menu')" url="/catalogs" v-if="multiInventoryActivated && !isPosOnly">{{ $t('inventory.catalogs') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/inventory_hours">{{ $t('inventory.schedules') }}</NavigationLink>
            <template v-if="selectedInventory && selectedInventory.orderRequirementsActivated">
              <NavigationLink dot @click="$emit('close-menu')" url="/order-requirements">{{ $t('inventory.order_requirements') }}</NavigationLink>
            </template>
            <NavigationLink dot @click="$emit('close-menu')" url="/tags">{{ $t('inventory.tags') }}</NavigationLink>
          </Collapse>
          <NavigationLink v-if="moduleActivated.POS" dot @click="$emit('close-menu')" url="/revenue-centers">{{ $t('revenue_centers.title') }}</NavigationLink>
          <template v-if="selectedInventory && selectedInventory.brandingActivated">
            <NavigationLink dot @click="$emit('close-menu')" url="/brandings">{{ $t('branding.title') }}</NavigationLink>
          </template>
          <template v-if="moduleActivated.aimsVouchers">
            <NavigationLink dot @click="$emit('close-menu')" url="/aims-tickets">{{ $t('ticket.title') }}</NavigationLink>
          </template>
          <NavigationLink dot @click="$emit('close-menu')" url="/categories">{{ $t('inventory.categories') }}</NavigationLink>
          <NavigationLink dot @click="$emit('close-menu')" url="/items">{{ $t('inventory.items') }}</NavigationLink>
          <Collapse url="/menu/modifiers-hub" closed dot :text="$t('inventory.selection')">
            <NavigationLink dot @click="$emit('close-menu')" url="/modifiers">{{ $t('inventory.modifiers') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/choice-items">{{ $t('inventory.choices') }}</NavigationLink>
          </Collapse>
          <NavigationLink dot @click="$emit('close-menu')" url="/supplements" v-if="moduleActivated.onlineOrdering || moduleActivated.kiosk">{{ $t('inventory.supplements') }}</NavigationLink>
        </Collapse>

        <Collapse closed icon="icon/nav/config.svg" :text="$t('settings.title')">
          <NavigationLink dot @click="$emit('close-menu')" url="/branch-scheduled-shutdown">{{ $t('scheduled_shutdown.title') }}</NavigationLink>
        </Collapse>

        <Collapse closed icon="icon/nav/users.svg" :text="$t('users.title')" v-if="atLeastDistributor" url="/branch/user-hub">
          <NavigationLink dot @click="$emit('close-menu')" url="/users/ROLE_ADMIN" v-if="atLeastSuperAdmin">{{ $t('roles.ROLE_BRANCH_ADMIN') }}</NavigationLink>
          <NavigationLink dot @click="$emit('close-menu')" url="/users/ROLE_DISPATCH" v-if="atLeastSuperAdmin && moduleActivated.dispatch">{{ $t('roles.ROLE_DISPATCH') }}</NavigationLink>
          <NavigationLink dot @click="$emit('close-menu')" url="/users/ROLE_RECEPTION">{{ $t('roles.ROLE_RECEPTION') }}</NavigationLink>
        </Collapse>

        <template v-if="atLeastBranchAdmin">
          <Collapse closed icon="icon/nav/analytics.svg" :text="$t('advanced_navigation.global_reports')" url="/global-reports-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/stats-builder">{{ $t('statistics.title') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/branch-statistics">{{ $t('statistics.branch_title') }}</NavigationLink>
            <Collapse dot closed :text="$t('sales.title')" url="/sales-hub">
              <NavigationLink dot @click="$emit('close-menu')" url="/sales">{{ $t('sales.title') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/report/sale">{{ $t('sale_report.title') }}</NavigationLink>
            </Collapse>
            <Collapse dot :text="$t('customers.title')" url="/branch-customers-hub" closed>
              <NavigationLink dot @click="$emit('close-menu')" url="/customers">{{ moduleActivated.dispatch ? $t('customers.online') : $t('customers.title') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" v-if="moduleActivated.dispatch" url="/dispatch-customers">{{ $t('customers.dispatch') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/report/customer">{{ $t('advanced_navigation.customer_report') }}</NavigationLink>
            </Collapse>
            <template v-if="multiInventoryActivated">
              <NavigationLink dot @click="$emit('close-menu')" url="/report/inventory-out-of-stock">{{ $t('inventory_out_of_stock_report.title') }}</NavigationLink>
            </template>
            <template v-if="!exactlyDistributor && moduleActivated.loyalty">
              <NavigationLink dot @click="$emit('close-menu')" url="/gift-card-reports" v-if="isGiftCardActivated">{{$t('gift_card.title')}}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/loyalty-transaction-stat">{{ $t('loyalty_transactions.reports_title') }}</NavigationLink>
            </template>
          </Collapse>

          <Collapse url="/branch/marketing-hub" closed :text="$t('advanced_navigation.multi_marketing_tools')" icon="/icon/nav/marketing.svg">
            <template v-if="multiInventoryActivated">
              <NavigationLink dot @click="$emit('close-menu')" url="/promotions">{{ $t('promotions.title') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/promotion-modal" v-if="!isPosOnly">{{ $t('promotions.modal.title') }}</NavigationLink>
            </template>
            <NavigationLink dot @click="$emit('close-menu')" url="/newsletter">{{ $t('mailchimp.newsletter') }}</NavigationLink>
          </Collapse>

          <Collapse closed icon="icon/nav/loyalty.svg" :text="$t('loyalty.title')" v-if="!exactlyDistributor && moduleActivated.loyalty" url="/loyalty-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/loyalty-transactions">{{ $t('loyalty_transactions.list') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/loyalty-accounts">{{ $t('loyalty_accounts.list') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/gift-cards" v-if="isGiftCardActivated">{{$t('gift_card.card_list')}}</NavigationLink>
          </Collapse>

          <NavigationLink icon="icon/nav/media-library.svg" @click="$emit('close-menu')" url="/media-manager">{{ $t('media_manager.title') }}</NavigationLink>
        </template>
      </template>

      <!-- POS and reception navigation -->
      <template v-if="$route.query.branch && (exactlyClerk || exactlyPOS)">
        <NavigationLink @click="$emit('close-menu')" icon="/icon/wallet.svg" url="/reception">
          {{ $t('reception.title') }}
          <div class="pill" v-if="$store.state.sales.length > 0">{{$store.state.sales.length}}</div>
        </NavigationLink>
      </template>
      <template v-if="$route.query.branch && exactlyPOS">
        <NavigationLink url="/pos" @click="$emit('close-menu')" icon="/icon/wallet.svg">POS</NavigationLink>
      </template>

      <!-- Company admin navigation -->
      <template v-if="$route.query.branch && $route.query.company && (atLeastClerk || exactlyPOS)">

        <template v-if="atLeastBranchAdmin">
          <NavigationLink :custom-url="{ path: '/companies', query: { branch: $route.query.branch }}" icon="/icon/back.svg" @click="$emit('close-menu')">
            {{ $t('navigation.back_to_branch_admin') }}
          </NavigationLink>
        </template>

        <NavigationLink icon="icon/internet.svg" @click="$emit('close-menu')" v-if="moduleActivated.onlineOrdering"
                        :external-url="frontendBranchUrl">{{ $t('open_online_ordering') }}</NavigationLink>

        <Collapse closed v-if="atLeastDistributor" :text="getContextName" icon="/icon/nav/revenue-center.svg" url="/company-hub">
          <NavigationLink dot @click="$emit('close-menu')" url="/company/edit">{{ $t('settings_admin.company') }}</NavigationLink>
          <NavigationLink dot @click="$emit('close-menu')" url="/company/services" v-if="atLeastSuperAdmin">{{ $t('services.title') }}</NavigationLink>
          <NavigationLink dot @click="$emit('close-menu')" url="/company/paid-features" v-if="atLeastSuperAdmin">{{ $t('paid_features.title') }}</NavigationLink>

          <Collapse dot closed :text="$t('companies.settings.externalPos')" url="/external-pos-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/settings/external-pos" >{{ $t('configuration') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/settings/tunnel">{{ $t('companies.settings.tunnel') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/external_pos_synchronisation">{{ $t('synchronisation') }}</NavigationLink>
          </Collapse>

          <Collapse dot closed :text="$t('advanced_navigation.global_settings')" url="/company/global-settings-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/settings/payment" v-if="$store.getters.loggedUserHasViewPaymentSettingsPermission">{{ $t('companies.settings.payment') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/settings/shipper" v-if="atLeastSuperAdmin">{{ $t('companies.settings.shipper') }}</NavigationLink><template v-if="!exactlyDistributor">
              <NavigationLink dot @click="$emit('close-menu')" url="/loyalty-config">{{ $t('loyalty.title') }}</NavigationLink>
            </template>
          </Collapse>

          <Collapse dot closed :text="$t('advanced_navigation.support')" url="/company/support-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/failed-sales">{{ $t('advanced_navigation.failed_sales') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/test-sales">{{ $t('advanced_navigation.test_sales') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/create-test-sale">{{ $t('advanced_navigation.create_sale') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/role-permissions" v-if="$store.getters.loggedUserHasModifyPermission">{{ $t('settings.permissions') }}</NavigationLink>
          </Collapse>

          <NavigationLink dot @click="$emit('close-menu')" url="/inventory-power-user">{{ $t('inventory_power_user.title') }}</NavigationLink>
        </Collapse>

        <NavigationLink url="/quick-config" icon="/icon/nav/config.svg" @click="$emit('close-menu')"
                        v-if="moduleActivated.onlineOrdering || moduleActivated.kiosk">{{ $t('companies.settings.quick') }}</NavigationLink>

        <template v-if="atLeastCompanyAdmin">
          <Collapse url="/menu/hub" :text="$t('inventory.title')" icon="/icon/nav/inventory.svg">
            <Collapse url="/menu/configuration-hub" closed dot :text="$t('configuration')">
              <NavigationLink dot @click="$emit('close-menu')" url="/inventory" v-if="atLeastSuperAdmin">{{ $t('inventory.current_menu_settings') }}</NavigationLink>
              <template v-if="$store.getters.isBranchContextInventory && canManageCatalog">
                <NavigationLink dot @click="$emit('close-menu')" url="/catalog/company-catalogs">{{ $t('inventory.catalogs') }}</NavigationLink>
              </template>
              <template v-if="!$store.getters.isBranchContextInventory && !isPosOnly">
                <NavigationLink dot @click="$emit('close-menu')" url="/catalogs">{{ $t('inventory.catalogs') }}</NavigationLink>
              </template>
              <NavigationLink dot @click="$emit('close-menu')" url="/inventory_hours">{{ $t('inventory.schedules') }}</NavigationLink>
              <template v-if="selectedInventory && selectedInventory.orderRequirementsActivated">
                <NavigationLink dot @click="$emit('close-menu')" url="/order-requirements">{{ $t('inventory.order_requirements') }}</NavigationLink>
              </template>
              <NavigationLink v-if="isMaitreDPOS" dot @click="$emit('close-menu')" url="/settings/maitred-sync">{{ $t('inventory.pos_price_sync') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/tags">{{ $t('inventory.tags') }}</NavigationLink>
            </Collapse>
            <NavigationLink v-if="moduleActivated.POS" dot @click="$emit('close-menu')" url="/revenue-centers">{{ $t('revenue_centers.title') }}</NavigationLink>
            <template v-if="selectedInventory && selectedInventory.brandingActivated">
              <NavigationLink dot @click="$emit('close-menu')" url="/brandings">{{ $t('branding.title') }}</NavigationLink>
            </template>
            <template v-if="moduleActivated.aimsVouchers">
              <NavigationLink dot @click="$emit('close-menu')" url="/aims-tickets">{{ $t('ticket.title') }}</NavigationLink>
            </template>
            <NavigationLink dot @click="$emit('close-menu')" url="/categories">{{ $t('inventory.categories') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/items">{{ $t('inventory.items') }}</NavigationLink>
            <Collapse url="/menu/modifiers-hub" closed dot :text="$t('inventory.selection')">
              <NavigationLink dot @click="$emit('close-menu')" url="/modifiers">{{ $t('inventory.modifiers') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/choice-items">{{ $t('inventory.choices') }}</NavigationLink>
            </Collapse>
            <NavigationLink dot @click="$emit('close-menu')" url="/supplements" v-if="moduleActivated.onlineOrdering || moduleActivated.kiosk">{{ $t('inventory.supplements') }}</NavigationLink>
          </Collapse>

          <Collapse closed :text="$t('users.title')" icon="/icon/nav/users.svg" url="/company/user-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/users/ROLE_CLERK">{{ $t('roles.ROLE_CLERK') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/users/ROLE_ADMIN">{{ $t('roles.ROLE_COMPANY_ADMIN') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/users/ROLE_RECEPTION" v-if="atLeastDistributor">{{ $t('roles.ROLE_RECEPTION') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/employees" v-if="moduleActivated.POS">{{ $t('employees.title') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/roles" v-if="moduleActivated.POS">{{ $t('pos_roles.title') }}</NavigationLink>
          </Collapse>

          <Collapse closed :text="$t('settings.title')" icon="/icon/nav/config.svg" v-if="moduleActivated.POS" url="/pos-configuration-hub">
            <Collapse closed dot :text="$t('printers.printing')" url="/pos-printer-hub">
              <NavigationLink dot @click="$emit('close-menu')" url="/printers">{{ $t('printers.title') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/printer-groups">{{ $t('printer_groups.title') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/receipt-configuration">{{ $t('receipt_config.header_title') }}</NavigationLink>
            </Collapse>
            <NavigationLink dot @click="$emit('close-menu')" url="/pos/order-options">{{ $t('order_options.title') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/pos/visual-config">{{ $t('pos_visual_config.title') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/pos/mev-config" v-if="haveMevConfiguration">{{ $t('mev_config.title') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/licenses" v-if="atLeastSuperAdmin">{{ $t('licensing.title') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/users/ROLE_POS" v-if="atLeastSuperAdmin">{{ $t('roles.ROLE_POS') }}</NavigationLink>
          </Collapse>

          <Collapse closed :text="$t('advanced_navigation.global_reports')" icon="/icon/nav/analytics.svg" url="/global-reports-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/report/punch" v-if="moduleActivated.POS">{{ $t('timesheet.punch_admin') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/company-statistics" v-if="moduleActivated.onlineOrdering || moduleActivated.kiosk">{{ $t('stats.title') }}</NavigationLink>
            <Collapse dot closed :text="$t('sales.title')" url="sales-hub">
              <template v-if="!moduleActivated.payAtTheTable">
                <NavigationLink dot @click="$emit('close-menu')" url="/sales">{{ $t('sales.title')}}</NavigationLink>
              </template>
              <template v-if="moduleActivated.payAtTheTable">
                <NavigationLink dot @click="$emit('close-menu')" url="/sales">{{ $t('settings.online_ordering') }}</NavigationLink>
                <NavigationLink dot @click="$emit('close-menu')" url="/sales/table">{{ $t('services.qr_payment') }}</NavigationLink>
              </template>
              <NavigationLink dot @click="$emit('close-menu')" url="/report/sale">{{ $t('sale_report.title') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/pos-sales" v-if="moduleActivated.POS">{{ $t("pos.sales.pos_sales") }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/pos-invoices" v-if="moduleActivated.POS">{{ $t("pos.pos_invoices.pos_invoices") }}</NavigationLink>
            </Collapse>
            <template v-if="moduleActivated.POS">
              <NavigationLink dot @click="$emit('close-menu')" url="/tip-management">{{ $t('pos.tip_management.title') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/cash-drawer-management">{{ $t("pos.cash_drawer.management_title") }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/price-adjustments">{{ $t("pos.price_adjustments") }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/refunds">{{ $t("pos.refunds") }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/voids">{{ $t("pos.voids") }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/batch-reading">{{ $t("batch_reading.title") }}</NavigationLink>
            </template>
            <template v-if="moduleActivated.catering">
              <Collapse closed dot :text="$t('catering.title')" url="/catering-hub">
                <NavigationLink dot @click="$emit('close-menu')" url="/catering-sales">{{ $t('catering.sales') }}</NavigationLink>
                <NavigationLink dot @click="$emit('close-menu')" url="/catering-prep">{{ $t('catering.prep') }}</NavigationLink>
                <NavigationLink dot @click="$emit('close-menu')" url="/catering-deliveries">{{ $t('catering.deliveries') }}</NavigationLink>
              </Collapse>
            </template>
            <template v-if="moduleActivated.aimsVouchers">
              <NavigationLink dot @click="$emit('close-menu')" url="/custom-report-qr">{{ $t('custom_reports.codes_sales') }}</NavigationLink>
            </template>
            <template v-if="!exactlyDistributor && moduleActivated.loyalty">
              <NavigationLink dot @click="$emit('close-menu')" url="/gift-card-reports" v-if="isGiftCardActivated">{{$t('gift_card.title')}}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/loyalty-transaction-stat">{{ $t('loyalty_transactions.reports_title') }}</NavigationLink>
            </template>
          </Collapse>

          <Collapse closed :text="$t('advanced_navigation.marketing')" icon="/icon/nav/marketing.svg" url="/marketing-hub">
            <Collapse closed dot :text="$t('promotions.title')" v-if="!$store.getters.isBranchContextInventory" url="/promotion-hub">
              <NavigationLink dot @click="$emit('close-menu')" url="/promotions">{{ $t('promotions.title') }}</NavigationLink>
              <NavigationLink dot @click="$emit('close-menu')" url="/promotion-modal" v-if="!isPosOnly">{{ $t('promotions.modal.title') }}</NavigationLink>
            </Collapse>
            <NavigationLink dot @click="$emit('close-menu')" url="/settings/emails" v-if="moduleActivated.onlineOrdering">{{ $t('advanced_navigation.emails_configuration') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/upsell" v-if="!isPosOnly">{{ $t('inventory.upsell') }}</NavigationLink>
            <template v-if="!exactlyDistributor">
              <NavigationLink dot @click="$emit('close-menu')" url="/newsletter">{{ $t('mailchimp.newsletter')}}</NavigationLink>
            </template>
            <NavigationLink dot @click="$emit('close-menu')" url="/settings/presentation" v-if="moduleActivated.onlineOrdering">{{ $t('companies.settings.presentation') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/settings/services/menu-board"
                            v-if="moduleActivated.menuBoard && atLeastBranchAdmin">{{ $t('services.menuboard') }}</NavigationLink>
          </Collapse>

          <NavigationLink url="/settings/services/online-ordering" icon="/icon/nav/online-ordering.svg"
                          @click="$emit('close-menu')" v-if="moduleActivated.onlineOrdering">{{$t('services.online_ordering')}}</NavigationLink>

          <Collapse closed :text="$t('services.kiosk')" icon="/icon/nav/online-ordering.svg" v-if="moduleActivated.kiosk" url="/kiosk-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/settings/services/kiosk">{{ $t('settings.title') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/style/kiosk">{{ $t('style.title') }}</NavigationLink>
          </Collapse>

          <NavigationLink url="/settings/qr-payment" icon="/icon/nav/qr-payment.svg" @click="$emit('close-menu')"
                          v-if="moduleActivated.payAtTheTable">{{$t('services.qr_payment')}}</NavigationLink>

          <NavigationLink @click="$emit('close-menu')" url="/settings/uber-eats" icon="/icon/uber-eats.svg"
                          v-if="atLeastSuperAdmin || moduleActivated.uberEats">{{ $t('companies.settings.uber_eats') }}</NavigationLink>

          <Collapse closed :text="$t('loyalty.title')" icon="/icon/nav/loyalty.svg" v-if="isLoyaltyActivated && atLeastCompanyAdmin" url="/loyalty-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/loyalty-transactions">{{ $t('loyalty_transactions.list') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/loyalty-accounts">{{ $t('loyalty_accounts.list') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/gift-cards" v-if="isGiftCardActivated">{{$t('gift_card.card_list')}}</NavigationLink>
          </Collapse>
        </template>
      </template>

      <!-- global -->
      <collapse closed :text="$t('advanced_navigation.help_support')" icon="/icon/info.svg" url="/help-support-hub">
        <a class="link" :href="$to(Parameters.urlSupport)" target="_blank">
          <div class="dot"></div>
          {{ $t('advanced_navigation.faq') }}
        </a>
        <NavigationLink dot @click="$emit('close-menu')" url="/training">{{ $t('advanced_navigation.training') }}</NavigationLink>
        <template v-if="$store.state.contextCompany">
          <Collapse closed dot text="POS" url="/pos-help-support-hub">
            <NavigationLink dot @click="$emit('close-menu')" url="/check-external-pos-connection">{{ $t('external_pos_connection.check_external_pos') }}</NavigationLink>
            <NavigationLink dot @click="$emit('close-menu')" url="/qr-payment-requests">{{ $t('qr_payment_request.title') }}</NavigationLink>
            <PayfactoSupportUrl class="link" dot />
          </Collapse>
        </template>
      </collapse>
      <a class="link" href="javascript:void(0)" @click="checkForUpdate" v-if="isNwApp">
        <svgicon src="/icon/update.svg" class="icon" width="20" height="20"/>
        {{$t('download.update')}}
      </a>
    </div>

    <div class="footer-links">
      <NavigationLink url="/release-notes">{{ $t('release_notes.title') }}</NavigationLink>
      <a class="link" :href="$to(Parameters.urlMerchantTerms)" target="_blank">{{ $t('advanced_navigation.terms') }}</a>
    </div>
    <div class="footer-notes">
      Version {{version}} &copy; {{year}} iShopFood
    </div>
  </div>

</template>

<script>

  import Vue from 'vue';
  import NavigationLink from './navigation/Link.vue';
  import Collapse from './navigation/Collapse.vue';
  import PayfactoSupportUrl from "./PayfactoSupportUrl.vue";

  export default Vue.extend({

    name: 'navigation',

    components: {
      NavigationLink,
      Collapse,
      PayfactoSupportUrl
    },

    data() {
      return {
        Parameters,
        version: null,
        moduleActivated: {
          onlineOrdering: false,
          kiosk: false,
          mobileApp: false,
          menuBoard: false,
          loyalty: false,
          thirdPartyLoyalty: false,
          aimsVouchers: false,
          onSiteOrdering: false,
          payAtTheTable: false,
          catering: false,
          dispatch: false,
          uberEats: false,
          POS: false,
        }
      }
    },

    computed: {
      atLeastSuperAdmin() {
        return this.$store.getters.loggedUserHasSuperAdmin;
      },
      atLeastDistributor() {
        return this.$store.getters.loggedUserHasDistributor;
      },
      atLeastBranchAdmin() {
        return this.$store.getters.loggedUserHasBranchAdmin;
      },
      atLeastCompanyAdmin() {
        return this.$store.getters.loggedUserHasCompanyAdmin;
      },
      atLeastClerk() {
        return this.$store.getters.loggedUserHasClerkUser;
      },
      exactlySuperAdmin() {
        return this.$store.state.loggedUser.isSuperAdmin;
      },
      exactlyDistributor() {
        return this.$store.state.loggedUser.isDistributor;
      },
      exactlyClerk() {
        return this.$store.state.loggedUser.isClerkUser || this.$store.state.loggedUser.isReceptionUser;
      },
      exactlyPOS() {
        return this.$store.state.loggedUser.isPosUser
      },
      year() {
        let now = new Date();
        return now.getFullYear();
      },
      company() {
        return this.$store.state.contextCompany;
      },
      branch() {
        return this.$store.state.contextBranch;
      },
      getContextName() {
        if (this.branch && !this.company) {
          return this.branch.name;
        }
        if (this.branch && this.company) {
          return this.company.name;
        }
        return "";
      },
      isMaitreDPOS() {
        return this.company && this.company.activePOS && this.company.activePOS[0] === "maitre";
      },
      multiInventoryActivated() {
        return this.branch ? this.branch.inventories.length > 0 : false;
      },
      inventories() {
        return this.branch ? this.branch.inventories : [];
      },
      selectedInventory: {
        get() {
          return this.$store.state.contextInventory;
        },
        set(val) {
          this.$store.state.contextInventory = val;
          localStorage.setItem("context-inventory", val ? val.id : 0);
        }
      },
      selectInventoryDisabled() {
        return [
          '/category/edit', '/item/new', '/item/edit',
          '/modifiers/edit', '/modifier-groups/edit',
          '/choice-items/edit', '/choices/edit', '/choice-groups/edit',
          '/supplement/new', '/supplement/edit'
        ].includes(this.$route.path);
      },
      isLoyaltyActivated() {
        return this.branch && this.branch.loyaltyConfig && this.branch.loyaltyConfig.activated;
      },
      isGiftCardActivated() {
        return this.branch && this.branch.loyaltyConfig && this.branch.loyaltyConfig.data && this.branch.loyaltyConfig.data.giftCardActivated;
      },
      canManageCatalog() {
        let fields = this.$store.getters.getOverloadableFields;
        if (!this.$route.query.company || !this.$store.getters.isBranchContextInventory || fields.length === 0) {
          return false;
        }
        return fields.indexOf("catalogExclusions") > -1;
      },
      isNwApp() {
        return isExecutable();
      },
      frontendBranchUrl() {
        let contextServer = this.$store.state.contextServer;
        let contextBranch = this.$store.state.contextBranch;

        let serverBaseUrl = contextServer && contextServer.urlFrontend ? contextServer.urlFrontend : 'https://web.ishopfood.com';
        let branchNameCanonical = contextBranch ? contextBranch.nameCanonical : '';

        return `${serverBaseUrl}/#/${branchNameCanonical}`
      },
      hasAtLeastOneOnlineOrderingPlatformActive() {
        let validKeys = ["POS", "thirdPartyLoyalty", "loyalty"];
        for (const [key, value] of Object.entries(this.moduleActivated)) {
          if (value && !validKeys.includes(key)) {
            return true;
          }
        }
        return false;
      },
      isPosOnly() {
        return this.moduleActivated.POS && !this.hasAtLeastOneOnlineOrderingPlatformActive;
      },
      haveMevConfiguration() {
        return this.company && this.company.country === "CA" && this.company.region === "QC";
      }
    },

    mounted() {
      this.getLocalBackendVersion();
      this.addActiveClassToCollapse();
    },

    watch: {
      "$route.query": {
        immediate: true,
        async handler(val) {
          if (val.branch) {
            let branchModule = await this.$store.getters.getContextBranchActivatedModule;
            Object.assign(this.moduleActivated, branchModule)
          }
          if (val.company) {
            let companyModule = await this.$store.getters.getContextCompanyActivatedModule;
            Object.assign(this.moduleActivated, companyModule)
          }
        }
      },
      "$route": function () {
        this.addActiveClassToCollapse();
      }
    },

    methods: {
      addActiveClassToCollapse() {
        setTimeout(() => {
          // Add collapsible navigation elements
          let collapses = Array.from(document.getElementsByClassName("collapsible-container"));
          // Add non-collapsible navigation elements
          collapses = [...collapses, ...Array.from(document.getElementsByClassName("main-navigation")[0].children).filter(c => c.classList.contains("link"))]
          let activeCollapses = [];
          let activeLink = null;
          for (let collapse of collapses) {
            // Check if the collapsible element has an active link
            let hasActiveLink = collapse.getElementsByClassName("router-link-active").length > 0;
            if (hasActiveLink) {
              collapse.classList.add("active");
              collapse.classList.add("show");
              activeCollapses.push(collapse.querySelector("a.link"));
              activeLink = collapse.getElementsByClassName("router-link-active")[0];
            } else {
              collapse.classList.remove("active");
            }
            // Check if the element is a non-collapsible active link
            let isActiveLink = collapse.classList.contains("router-link-active");
            if (isActiveLink) {
              activeCollapses.push(collapse);
            }
          }
          if (activeLink && activeLink.parentElement.classList.contains("holder")) {
            activeLink = null;
          }
          let links = [...activeCollapses, activeLink].filter(l => l);
          let breadcrumbs = links.map(l => {
            return {
              name: l.innerText,
              href: l.href.split("#")[1]
            };
          });
          this.$store.state.breadcrumbs = breadcrumbs;
        }, 0);
      },
      async getLocalBackendVersion() {
        let response = await fetch("version.txt");
        this.version = await response.text();
      },
      checkForUpdate() {
        window.update();
      },
      collapse(e) {
        e.target.parentNode.classList.toggle("show");
      }
    }
  });

</script>


<style lang="scss" scoped>
  #navigation {
    background-color: #000;
    box-shadow: inset 0 0 5px 0 #020302;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .main-navigation {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar-thumb {
      box-shadow: inset 0 0 10px 10px #404040 !important;
    }
  }
  .footer-notes {
    padding: 16px;
    font-size: 12px;
    color: #808080;
  }
  #navigation .footer-links {
    .link {
      font-size: 12px;
      color: #bfbfbf;
      border: none;
      padding: 5px 20px;
    }
  }
  .inventory-select-holder {
    position: relative;
    margin-left: 50px;
    margin-bottom: 10px;

    .inventory-select {
      background-color: transparent;
      border-color: #333333;
      font-size: 14px;
      color: white;
      width: 90%;
      padding: 20px 10px 4px 10px;

      option {
        color: black;
      }
    }

    label {
      position: absolute;
      top: 7px;
      left: 15px;
      font-size: 12px;
    }
  }
</style>

<style lang="scss">
#navigation .link {
  .pill {
    background-color: var(--primary-color);
    margin-left: 15px;
    min-width: 20px;
    height: 20px;
    padding: 5px;
    border-radius: 15px;
    color: white;
    font-weight: bold;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
